module.exports = __webpack_public_path__ + "static/media/ecology-white.48b6f7b1.svg";